import { Component, Input, Output, EventEmitter, input, output } from '@angular/core';
import { formatSize } from '@src/app/core/utils/file.utils';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-logo-file-item',
  imports: [
    ButtonModule
  ],
  templateUrl: './logo-file-item.component.html',
  styleUrl: './logo-file-item.component.scss'
})
export class LogoFileItemComponent {
  file = input<any>();
  index = input<number>(0);
  showRemove = input<boolean>(true);
  remove = output<[Event, number]>();

  formatSize = formatSize;

  onRemove(event: Event) {
    this.remove.emit([event, this.index()]);
  }
}
